var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerProgramMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C13.448 11 13 11.4477 13 12C13 12.5523 13.448 13 14 13H20C20.552 13 21 12.5523 21 12C21 11.4477 20.552 11 20 11H14ZM17 15C16.448 15 16 15.4477 16 16C16 16.5523 16.448 17 17 17H20C20.552 17 21 16.5523 21 16C21 15.4477 20.552 15 20 15H17Z",
    fill: "#404D6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C14.5 7.4477 14.948 7 15.5 7H20.5C21.052 7 21.5 7.4477 21.5 8C21.5 8.5523 21.052 9 20.5 9H15.5C14.948 9 14.5 8.5523 14.5 8Z",
    fill: "#404D6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.5C4 5.015 6.015 3 8.5 3C10.985 3 13 5.015 13 7.5C13 9.985 10.985 12 8.5 12C6.015 12 4 9.985 4 7.5Z",
    fill: "#6B758B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 15.956 3.22801 14.101 5.06201 13.344C5.31801 13.238 5.59199 13.26 5.84399 13.375C6.75999 13.792 7.625 14 8.5 14C9.378 14 10.24 13.803 11.125 13.406C11.381 13.292 11.68 13.295 11.938 13.406C13.765 14.194 15 16.004 15 18V20C15 20.552 14.552 21 14 21H3C2.448 21 2 20.552 2 20V18Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerProgramMenu);
export default __webpack_public_path__ + "static/media/Partner-Program-menu.befc756de2d214dde4e599f383205809.svg";
export { ForwardRef as ReactComponent };